import { render, staticRenderFns } from "./Lineup.vue?vue&type=template&id=3610c1f3&"
import script from "./Lineup.vue?vue&type=script&lang=ts&"
export * from "./Lineup.vue?vue&type=script&lang=ts&"
import style0 from "./Lineup.vue?vue&type=style&index=0&id=3610c1f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports